import getViewState from './getViewState';

export default function getIsDirty(viewStateId: string): boolean {
    return getViewState(viewStateId).isDirty;
}
